import React from 'react'

interface SettingLogoProps {
	width?: number | string
	height?: number | string
	color?: string
	onClick?: () => void
	style?: React.CSSProperties
}

const SettingLogo: React.FC<SettingLogoProps> = ({
	width = 24,
	height = 24,
	color = '#7F7F84',
	onClick,
	style,
}) => (
	<svg
		width={width}
		height={height}
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		onClick={onClick}
		style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
	>
		<circle cx='12' cy='12' r='7' stroke={color} strokeWidth='2' />
		<path d='M11 3H13V5H11V3Z' stroke={color} strokeWidth='2' />
		<path d='M21 11V13H20V11H21Z' stroke={color} strokeWidth='2' />
		<path d='M4 11V13H3V11H4Z' stroke={color} strokeWidth='2' />
		<path
			d='M17.6567 4.92886L19.0709 6.34307L18.1409 7.27316L16.7267 5.85895L17.6567 4.92886Z'
			stroke={color}
			strokeWidth='2'
		/>
		<path
			d='M5.9541 16.6315L7.36831 18.0457L6.34301 19.071L4.9288 17.6568L5.9541 16.6315Z'
			stroke={color}
			strokeWidth='2'
		/>
		<path d='M11 19H13V21H11V19Z' stroke={color} strokeWidth='2' />
		<path
			d='M4.92886 6.34326L6.34307 4.92905L7.30865 5.89462L5.89444 7.30883L4.92886 6.34326Z'
			stroke={color}
			strokeWidth='2'
		/>
		<path
			d='M16.5714 17.9858L17.9857 16.5716L19.071 17.6569L17.6568 19.0712L16.5714 17.9858Z'
			stroke={color}
			strokeWidth='2'
		/>
	</svg>
)

export default SettingLogo
